import React, { memo } from "react";
import { Loading as LoadingIcon } from "@op/opds.opux";

const Loading = memo(() => (
  <LoadingIcon id="CFF-loading" className="cff-loading" />
));

export default Loading;
